import { isDate } from 'lodash'
import moment from 'moment'

export const dateDiffToHHMMSS = (date1?: string, date2?: string, withHourPrefix = false): string | null => {
  if (!date1 || !date2) return null

  const d1 = new Date(date1),
    d2 = new Date(date2)

  if (isDate(d1) && isDate(d2)) {
    return dateToHHMMSS(d1.getTime() - d2.getTime(), withHourPrefix)
  }
  return null
}

export const dateDiffToMMSS = (date1?: string, date2?: string): string | null => {
  if (!date1 || !date2) return null

  const d1 = new Date(date1),
    d2 = new Date(date2)

  if (isDate(d1) && isDate(d2)) {
    return dateToMMSS(d1.getTime() - d2.getTime())
  }
  return null
}

export const dateToHHMMSS = (time: string | number | null, withHourPrefix = false): string | null => {
  if (time) {
    return millisecondsToHuman(+time, withHourPrefix)
  }
  return null
}

export function millisecondsToHuman(ms: number, withHourPrefix = false): string {
  const seconds = Math.floor((ms / 1000) % 60)
  const minutes = Math.floor((ms / 1000 / 60) % 60)
  const hours = Math.floor((ms / 1000 / 3600) % 24)

  const humanized = [minutes.toString().padStart(2, '0'), seconds.toString().padStart(2, '0')]

  if (hours > 0 || withHourPrefix) {
    humanized.unshift(hours.toString().padStart(hours > 0 ? 2 : 1, '0'))
  }

  return humanized.join(':')
}

export const dateToMMSS = (time: string | number | null): string | null => {
  if (time) {
    return millisecondsToHumanMMSS(+time)
  }
  return null
}

export function millisecondsToHumanMMSS(ms: number): string {
  const seconds = Math.floor((ms / 1000) % 60)
  const minutes = Math.floor((ms / 1000 / 60) % 60)

  const humanized = [minutes.toString().padStart(2, '0'), seconds.toString().padStart(2, '0')].join(':')

  return humanized
}

/**
 * Format specified date with AM PM suffix
 */
export const formatAMPM = (date: string | undefined): string => {
  if (!date) return ''

  const d = new Date(date)
  if (isDate(d)) {
    let hours = d.getHours()
    let minutes: string | number = d.getMinutes()
    const ampm = hours >= 12 ? 'PM' : 'AM'

    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes

    const strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }
  return date
}

/**
 * Format date with the specified separator
 */
export const formatDateTime = (date?: string, separator = '/'): string => {
  if (!date) return ''
  if (date === '---') return date
  const d = new Date(date)
  if (isDate(d)) {
    const year = d.getFullYear()
    let month = '' + (d.getMonth() + 1),
      day = '' + d.getDate()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [month, day, year].join(separator)
  }
  return date
}

export const formatDateOnly = (date?: string): string => {
  if (!date) return ''
  if (date === '---') return date
  return moment(date).format('MM/DD/YYYY')
}

/**
 * Formats a given date string by adding AM / PM
 */
export const formatDateWithAMPM = (value?: string, separator = '/', connectorString?: string): string => {
  if (!value) return ''
  const date = Date.parse(value)
  if (!isNaN(date)) {
    return `${formatDateTime(value, separator)} ${connectorString ? `${connectorString} ` : ''}${formatAMPM(value)}`
  }
  return ''
}
